var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-header" }, [
    _c("div", { staticClass: "page-header-start" }, [
      _vm.back
        ? _c("div", {
            staticClass: "page-header-start-icon",
            domProps: { innerHTML: _vm._s(_vm.iconBack) },
            on: {
              click: function($event) {
                return _vm.$emit("onBack")
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "page-header-start-title h1" }, [
        _vm._v("\n      " + _vm._s(_vm.title) + "\n    ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "page-header-end" }, [_vm._t("end")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }